module.exports = __webpack_public_path__ + "8fa6f65bff3baf7d6def461a153a9c90.svg";